import { lazy } from 'react'

export const HaveYouHeard = lazy(() => import('./HaveYouHeard'))
